const MODEL_COLOR_MAP = {
  BRAVO: '#FF0000',
  'BRAVO G4': '#332288',
  'BioSonic UC150': '#d6aacf',
  'BioSonic UC300': '#D5EB73',
  'BioSonic UC400': '#abbea3',
  'CanalPro Jeni': '#FF9800',
  'CanalPro Jeni Evo': '#F44336',
  Coltene: '#DDCC77',
  'Corporate DSO': '#44AA99',
  'DATA LOGGER BRAVO (G)': '#24716B',
  'DATA LOGGER BRAVO (T)': '#D95F02',
  'DATA LOGGER STATIM/HYDRIM': '#7570B3',
  Dealer: '#88CCEE',
  'End User': '#002BEB',
  'HYDRIM 112W G4+': '#117733',
  'HYDRIM 112WD G4+': '#2196F3',
  'HYDRIM C51W': '#E6AB02',
  'HYDRIM C51WD': '#66A61E',
  'HYDRIM C61W G4': '#9C27B0',
  'HYDRIM C61WD G4': '#00BCD4',
  'HYDRIM C61WD G4 OEM': '#5D6D7E',
  'HYDRIM L110W': '#002BEB',
  'HYDRIM L110W G4': '#88CCEE',
  'HYDRIM M2': '#2C3E50',
  'HYDRIM M2 G4': '#CC6677',
  'HYDRIM M2U': '#D5EB73',
  MILLFLASH: '#01EBC0',
  'STATCLAVE G4': '#4CAF50',
  'STATCLAVE G4 CA': '#4CAF50',
  'STATCLAVE G4 US': '#C0392B',
  'STATIM 2000 G4': '#FCD5B4',
  'STATIM 5000 G4': '#DDCC77',
  'STATIM 6000B': '#44AA99',
  'STATIM 7000': '#E7298A',
  'STATMATIC Smart': '#7f8c8d',
  Technician: '#88CCEE',
  Dentist: '#44AA99',
  'Customer Service': '#117733',
  Admin: '#CC6677',
  'Company Account': '#AA4499',
  'Dealer Technician': '#2196F3',
  'Technical Service': '#4CAF50',
  Sales: '#FF9800',
  Support: '#F44336',
  Partner: '#9C27B0',
  Distributor: '#00BCD4',
}

const CHART_COLORS = [
  '#332288',
  '#88CCEE',
  '#44AA99',
  '#117733',
  '#DDCC77',
  '#CC6677',
  '#AA4499',
  '#2196F3',
  '#4CAF50',
  '#FF9800',
  '#F44336',
  '#9C27B0',
  '#00BCD4',
  '#d6aacf',
  '#fbde00',
  '#abbea3',
  '#FCD5B4',
  '#FF0000',
  '#24716B',
  '#D95F02',
  '#7570B3',
  '#E6AB02',
  '#66A61E',
  '#E7298A',
  '#5D6D7E',
  '#002BEB',
  '#2C3E50',
  '#D5EB73',
  '#01EBC0',
  '#C0392B',
  '#7f8c8d',
]

export function getChartColor(model, fallbackIndex = 0) {
  if (model && MODEL_COLOR_MAP[model]) {
    return MODEL_COLOR_MAP[model]
  }
  return CHART_COLORS[fallbackIndex % CHART_COLORS.length]
}

export function getChartPalette() {
  return CHART_COLORS
}

export function getModelColorMap() {
  return MODEL_COLOR_MAP
}

export default CHART_COLORS
